import $ from 'jquery';

function initCollapseComponents(app) {
    const CollapseBase = {
        props: {
            label: String,
            labelShow: String,
            labelHide: String,
            labelSuffix: String,
            extraClass: String,
        },
        data() {
            return {
                show: false,
            };
        },
        methods: {
            toggle() {
                this.show = !this.show;
            },
        },
    };

    const Collapse = {
        extends: CollapseBase,
        props: {
            label: String,
        },
    };

    app.component('dropdown-filters', {
        props: {
            label: String,
            labelShow: String,
            labelHide: String,
            labelSuffix: String,
            extraClass: String,
        },
        data() {
            return {
                show: false,
            };
        },
        template: '#dropdown-filters',
        methods: {
            hide() {
                this.show = false;
            },
            toggle() {
                this.show = !this.show;
            },
        },
    });

    app.component('range-filter-control', {
        props: {
            filterKey: {},
            filterProperty: {
                type: Object,
                required: true,
            },
            valueHeader: {},
            valuesList: {},
            selectedValuePrefix: {},
        },
        data() {
            const minValueKey = `min${this.capitalizeFirstLetter(this.filterKey)}`;
            const maxValueKey = `max${this.capitalizeFirstLetter(this.filterKey)}`;

            return {
                minValueKey,
                maxValueKey,
                minSelected: this.filterProperty[minValueKey],
                maxSelected: this.filterProperty[maxValueKey],
                labels: {},
            };
        },
        template: '#rangeFilterControl',
        computed: {
            minValuesList() {
                return this.valuesList.filter((i) => this.maxSelected == null || i.value < this.maxSelected);
            },
            maxValuesList() {
                return this.valuesList.filter((i) => i.value > this.minSelected);
            },
            rangeLabel() {
                let label;
                const minValue = this.valuesList[0].value;
                const maxValue = this.valuesList[this.valuesList.length - 1].value;

                if ((!this.minSelected && !this.maxSelected) ||
                    (!this.minSelected && this.maxSelected === maxValue) ||
                    (this.minSelected === minValue && !this.maxSelected) ||
                    (this.minSelected === minValue && this.maxSelected === maxValue)) {
                    label = `${this.labels.anyLabel} ${this.valueHeader.toLowerCase()}`;
                } else {
                    const min = !this.minSelected ? 0 : this.valuesList.find((i) => i.value === this.minSelected).label;
                    const max = !this.maxSelected ? this.labels.maxLabel : this.valuesList.find((i) => i.value === this.maxSelected).label;

                    const prefix = this.selectedValuePrefix !== undefined ? this.selectedValuePrefix : `${this.valueHeader}: `;

                    label = `${prefix}${min} - ${max}`;
                }
                return label;
            },
        },
        methods: {
            initDefaultValues() {
                this.labels = {
                    anyLabel: this.$el.dataset['anyLabel'],
                    minLabel: this.$el.dataset['minLabel'],
                    maxLabel: this.$el.dataset['maxLabel'],
                };
            },
            capitalizeFirstLetter(str) {
                return str[0].toUpperCase() + str.slice(1);
            },
        },
        mounted() {
            this.initDefaultValues();
        },
    });

    app.component('more-filters', {
        extends: Collapse,
        template: '#more-filters',
    });

    app.component('collapsed-filter-panel', {
        extends: Collapse,
        template: '#collapsed-filter-panel',
        mounted() {
            $(this.$el).on('click', '.js-scrollup', this.scrollToClickedItem);
        },
        methods: {
            toggle() {
                this.show = !this.show;
                if (this.show) {
                    // NOTE: this fix prevents body scrolling while user works with search filters
                    $('html, body').addClass('no_scroll');
                } else {
                    $('html, body').removeClass('no_scroll');
                }
            },

            scrollToClickedItem(e) {
                const desktopLayoutMinWidth = 768;
                if (window.innerWidth < desktopLayoutMinWidth) {
                    setTimeout(() => {
                        const target = $(e.currentTarget);
                        const scrollContainer = $(this.$slots.default()[0].elm);

                        if (target.position().top !== 0) {
                            $(scrollContainer).animate({scrollTop: scrollContainer.scrollTop() + target.position().top});
                        }
                    });
                }
            },
            hideMoreFilter() {
                // Migration note. Trying to substitute this.$childrens
                const childsSlots = this.$slots.default();
                const moreFilterContainer = childsSlots.filter((c) => c?.$refs?.moreFilterContainer)[0];
                if (moreFilterContainer?.show) {
                    moreFilterContainer?.toggle();
                }
            },
        },
        directives: {
            'click-outside': {
                beforeMount(el, binding) {
                    const handler = (e) => {
                        if (!el.contains(e.target) && el !== e.target) {
                            binding.value(e);
                        }
                    };

                    el.__vueClickOutside__ = handler;
                    document.addEventListener('click', handler);
                },

                unmounted(el) {
                    document.removeEventListener('click', el.__vueClickOutside__);
                    el.__vueClickOutside__ = null;
                },
            },
        },
    });

    app.component('expander', {
        extends: Collapse,
        template: '#expander',
    });

    app.component('filter-expander', {
        extends: Collapse,
        template: '#filter-expander',
    });

    const CollapseBaseSeo = {
        extends: CollapseBase,
        methods: {
            markRendered(elem) {
                if (elem) {
                    elem['isAlreadyRendered'] = true;
                }
            },
            getHiddenOptions() {
                return this.options.filter((option) => !option.isAlreadyRendered);
            },
        },
    };

    app.component('city-landing-expand', {
        extends: CollapseBaseSeo,
        template: '#city-landing-expand',
        props: {
            options: {required: true},
            columns: {required: false, default: 1},
            stepRows: {required: false, default: 4},
        },
        data() {
            return {
                shownOptions: 0,
            };
        },
        watch: {
            options() {
                this.shownOptions = 0;
                this.showNextOptions();
            },
        },
        computed: {
            canExpand() {
                return this.shownOptions !== this.options.length;
            },
            hasMultipleColumns() {
                return this.columns > 1;
            },
            hasExpander() {
                return this.allOptionsCount > this.stepOptionsCount;
            },
            allOptionsCount() {
                return this.options.length;
            },
            stepOptionsCount() {
                return this.columns * this.stepRows;
            },
            styleObject() {
                return {
                    gridTemplateColumns: `repeat(${this.columns}, 1fr)`,
                };
            },
        },
        methods: {
            toggle() {
                if (!this.canExpand) {
                    this.shownOptions = 0;
                }

                this.showNextOptions();
            },
            showNextOptions() {
                this.shownOptions = Math.min(this.shownOptions + this.stepOptionsCount, this.allOptionsCount);
            },
            getOptionsCountByColumn(column) {
                let count = Math.floor(this.shownOptions / this.columns);

                if (column < this.shownOptions % this.columns) {
                    count++;
                }

                return count;
            },
            getOptionById(column, id) {
                const optionId = this.columns * id + column;
                this.markRendered(this.options[optionId]);
                return this.options[optionId];
            },
        },
        created() {
            this.showNextOptions();
        },
    });

    app.component('city-landing-map-expand', {
        extends: CollapseBaseSeo,
        template: '#city-landing-map-expand',
        props: {
            options: {required: true},
        },
        data() {
            return {
                shownOptions: 0,
                stepOptions: 6,
            };
        },
        computed: {
            canExpand() {
                return this.shownOptions !== this.options.length;
            },
            hasExpander() {
                return this.allOptionsCount > this.stepOptions;
            },
            allOptionsCount() {
                return this.options.length;
            },
            shownMaps() {
                let value = this.shownOptions / this.stepOptions;

                if (this.shownOptions % this.stepOptions != 0) {
                    value++;
                }

                return value;
            },
        },
        methods: {
            toggle() {
                if (!this.canExpand) {
                    this.shownOptions = 0;
                }

                this.showNextOptions();
            },
            showNextOptions() {
                this.shownOptions = Math.min(this.shownOptions + this.stepOptions, this.allOptionsCount);
            },
            getOptionsCountByMap(map) {
                const maxFullMaps = Math.floor(this.allOptionsCount / this.stepOptions);

                if (map <= maxFullMaps) {
                    return this.stepOptions;
                } else {
                    return this.allOptionsCount % this.stepOptions;
                }
            },
            getOptionById(map, id) {
                const index = map * this.stepOptions + id;
                this.markRendered(this.options[index]);
                return this.options[index];
            },
        },
        created() {
            this.showNextOptions();
        },
    });

    app.component('city-landing-search-expand', {
        extends: CollapseBase,
        template: '#city-landing-search-expand',
        props: {
            placeholder: {required: false},
            options: {required: true},
            columns: {required: false, default: 1},
            stepRows: {required: false, default: 4},
            fallbackLink: {required: false},
        },
        data() {
            return {
                value: ''
            };
        },
        computed: {
            filteredOptions() {
                if (!this.value) {
                    return this.options;
                }

                const lowerCaseValue = this.value.toLowerCase();
                return this.options.filter((x) => x.label.toLowerCase().includes(lowerCaseValue));
            },
            hasFilteredOptions() {
                return this.filteredOptions.length != 0;
            },
        }
    });
}

export default initCollapseComponents;
